export default "__VITE_ASSET__310f5c9b__"